<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Breadcrumb from "@/components/breadcrumb/en/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="margin-bottom : 40px; text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">User Stations</span></p>'
      + '<p style="margin-bottom : 0px"><span style="font-size: 16px;">By September 2020, 34 user stations have been admitted among over 80 applicants. More than 300 researchers carry out their research activities at Minhang Base.</span></p>'

      +'<table style="margin-left : 5px; margin-top : 30px; align-content: center; font-size: 16px; text-align: left;  ">'
      // +'<tr style="background-color: #033d80; color: white; vertical-align: center">'
      // +'<th style="border: solid 1px #2ba8e2;width: 60px">NO.</th><th style="border: solid 1px #2ba8e2;width: 840px">User Stations</th>'
      // +'</tr>'

      +'<tr style="align: left; height: 50px;">'
      +'<td style="vertical-align: middle">1. </td><td style="vertical-align: middle;margin-left : 10px; ">Institute of Medical Robotics</td>'
      +'</tr>'

      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">2. </td><td style="vertical-align: middle;margin-left : 10px; ">SJTU-Lantong ADC Payload Lab</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">3. </td><td style="vertical-align: middle;margin-left : 10px; ">Metal/Polymer Joining for Biomedical Applications</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">4. </td><td style="vertical-align: middle;margin-left : 10px; ">Development of Colorectal Cancer Early Diagnosis System</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">5. </td><td style="vertical-align: middle;margin-left : 10px; ">Hydrogen Medical Research Center</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">6. </td><td style="vertical-align: middle;margin-left : 10px; ">Nucleic Acids Design and Therapeutics</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">7. </td><td style="vertical-align: middle;margin-left : 10px; ">SJTU-Yale Biomedical Data Analysis Platform</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">8. </td><td style="vertical-align: middle;margin-left : 10px; ">National Clinical Research Center for Metabolic Diseases — Thermofisher Lab</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">9. </td><td style="vertical-align: middle;margin-left : 10px; ">Biodegradable Mg/Zn Based Materials for Medical Devices</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">10. </td><td style="vertical-align: middle;margin-left : 10px; ">Biomolecular Interaction Analysis Technology and Instrumentation</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">11. </td><td style="vertical-align: middle;margin-left : 10px; ">Development of Biodegradable Mg Biliary Stent</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">12. </td><td style="vertical-align: middle;margin-left : 10px; ">National Clinical Research Center for Metabolic Diseases — BGI Lab</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">13. </td><td style="vertical-align: middle;margin-left : 10px; ">Digital Medicine and Bioprinting</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">14. </td><td style="vertical-align: middle;margin-left : 10px; ">Automatic Optical Microscopy</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">15. </td><td style="vertical-align: middle;margin-left : 10px; ">Preclinical Evaluation of Innovative Targeted Therapeutics</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">16. </td><td style="vertical-align: middle;margin-left : 10px; ">Development of Clinical Electrophoretic Diagnostic Equipment</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">17. </td><td style="vertical-align: middle;margin-left : 10px; ">Functional Elucidations and Medical Applications of Novel Gene Editing Enzymes</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">18. </td><td style="vertical-align: middle;margin-left : 10px; ">Biomimetic Chiral Hydrogels Materials</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">19. </td><td style="vertical-align: middle;margin-left : 10px; ">Key Technology Development of Liquid Biochip for Cancer Early Diagnosis</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">20. </td><td style="vertical-align: middle;margin-left : 10px; ">Fundamental and Translational Research of Oncology Supportive Care Drugs</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">21. </td><td style="vertical-align: middle;margin-left : 10px; ">Lab of Metallic Implants Made with Micro-Casting Technology</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">22. </td><td style="vertical-align: middle;margin-left : 10px; ">Mechanism and Technology of L&M Network</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">23. </td><td style="vertical-align: middle;margin-left : 10px; ">Translational Medicine Research Workstation of Shanghai Institute of Biliary Diseases</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">24. </td><td style="vertical-align: middle;margin-left : 10px; ">Shanghai Institute of Traumatology and Orthopaedics-Regenerative Medicine Group</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">25. </td><td style="vertical-align: middle;margin-left : 10px; ">Shanghai Institute of Traumatology and Orthopaedics-Photo Medicine Group</td>'
      +'</tr>'

      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">26. </td><td style="vertical-align: middle;margin-left : 10px; ">Shanghai Institute of Traumatology and Orthopaedics-Imaging Medicine Group</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">27. </td><td style="vertical-align: middle;margin-left : 10px; ">High Throughput Screening Platform for Emerging Contaminants and The Health Effects</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">28. </td><td style="vertical-align: middle;margin-left : 10px; ">Biomimetic Synthesis of Neutrophil Extracellular Traps (Nets) For Understanding Nets-Associated Pathology and Regulation of Immune Disorders</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">29. </td><td style="vertical-align: middle;margin-left : 10px; ">Construction and Clinical Application of the Biomaterials for Accurate Diagnosis And Treatment of Drug-Resistant Tumors</td>'
      +'</tr>'
      +'<tr style="align: center; height: 50px;">'
      +'<td style="vertical-align: middle">30. </td><td style="vertical-align: middle;margin-left : 10px; ">Research and Application of Implant Medical Metals</td>'
      +'</tr>'
      +'</table>'
      + '<p>&nbsp;</p>'
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
  }
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/kyuser3/en/index.vue